<template>
  <div class="screen">
    <!-- <div class="row header">
     <mhead  :title="$route.meta.title"/>
    </div> -->
    <div class="row content" >
      <div class="row" v-if="root.device != 'phone'">
        <div class="col"  >
          <div class="row" style="flex-direction: column">
            <div  class="col hyzb" >
              <div class="ttt">
                <cusbox txt="会员指标">
                  <div v-if="membershipIndicatorsStatus" class="vcontent">
                    <!-- <div class="vcontent" >                                -->
                    <div class="vrow1">
                      <div class="row">
                        <div class="vitem">
                          <div class="vt1">会员总数</div>
                          <div class="vt2">
                            {{ data2[0].value / 10000
                            }}<font class="ten_thousand">万</font>
                            <div class="tip">
                              <span
                                class="animation"
                                style="position: absolute"
                                v-if="data2[0].state == 'up'"
                                >+{{ data2[0].changValue }}</span
                              >
                            </div>
                          </div>
                        </div>
                        <div class="vitem">
                          <div class="vt1">新增</div>
                          <div class="vt2">
                            {{ data2[1].value / 10000
                            }}<font class="ten_thousand">万</font>
                            <div class="tip">
                              <span
                                class="animation"
                                style="position: absolute"
                                v-if="data2[1].state == 'up'"
                                >+{{ data2[1].changValue }}</span
                              >
                            </div>
                          </div>
                        </div>
                        <div class="vitem">
                          <div class="vt1">去年同期新增</div>
                          <div class="vt2">
                            {{ data2[2].value / 10000
                            }}<font class="ten_thousand">万</font>
                            <!-- <div class="tip">
                                                                        <span class="animation" style="position: absolute;" v-if="data2[2].state=='up'">+{{data2[2].changValue}}</span>
                                                                    </div> -->
                          </div>
                        </div>
                      </div>
                      <div class="row" >
                        <div class="vitem">
                          <div class="vt1">有效会员</div>
                          <div class="vt2">
                            {{ data2[3].value / 10000
                            }}<font class="ten_thousand">万</font>
                            <div class="tip">
                              <span
                                class="animation"
                                style="position: absolute"
                                v-if="data2[3].state == 'up'"
                                >+{{ data2[3].changValue }}</span
                              >
                            </div>
                          </div>
                        </div>
                        <div class="vitem">
                          <div class="vt1">平均件单价</div>
                          <div class="vt2">
                            {{ data2[4].value
                            }}<font class="ten_thousand">元</font>
                            <!-- <div class="tip">
                                                                         <span class="animation" style="position: absolute;" v-if="data2[4].state=='up'">+{{data2[4].changValue}}</span>
                                                                    </div> -->
                          </div>
                        </div>
                        <div class="vitem">
                          <div class="vt1">平均客单价</div>
                          <div class="vt2">
                            {{ data2[5].value
                            }}<font class="ten_thousand">元</font>
                            <!-- <div class="tip">
                                                                        <span class="animation" style="position: absolute;" v-if="data2[5].state=='up'">+{{data2[5].changValue}}</span>
                                                                    </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <dv-loading v-if="!membershipIndicatorsStatus"
                    >Loading...</dv-loading
                  >
                </cusbox>
              </div>
            </div>
            <div class="col" >
              <div class="ttt">
                <cusbox txt="会员消费排行 TOP50">
                  <dv-loading v-if="!memberConsumptionRankStatus"
                    >Loading...</dv-loading
                  >
                  <barChartX2
                    v-show="memberConsumptionRankStatus"
                    :radius="radius"
                    ref="member_consumption"
                    type="member_consumption"
                    :data="x2data"
                  />
                </cusbox>
              </div>
            </div>
            <div class="col">
              <div class="ttt">
                <cusbox txt="会员等级及活跃度">
                  <barChartY2
                    v-show="membershipLevelAndActivityStatus"
                    ref="aaa"
                  />
                  <dv-loading v-if="!membershipLevelAndActivityStatus"
                    >Loading...</dv-loading
                  >
                </cusbox>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="row" style="flex-direction: column">
            <div class="col" >
              <div class="ttt">
                <cusbox txt="渠道会员占比">
                  <barChart
                    v-show="proportionChannelMembersStatus"
                    :data="obj"
                    ref="channel_member"
                  />
                  <dv-loading v-if="!proportionChannelMembersStatus"
                    >Loading...</dv-loading
                  >
                </cusbox>
              </div>
            </div>
            <div class="col">
              <div class="ttt">
                <cusbox txt="活跃会员数门店排行 TOP20">
                  <barChartX2
                    v-show="activeMemberStoreRankingStatus"
                    ref="shopactive_members"
                    type="shopactive_members"
                    :radius="radius"
                    :data="x2data"
                  />
                  <dv-loading v-if="!activeMemberStoreRankingStatus"
                    >Loading...</dv-loading
                  >
                </cusbox>
              </div>
            </div>
            <div class="col">
              <div class="row">
                <div class="col">
                  <div class="ttt">
                    <cusbox txt="消费年龄趋势分析">
                      <lineChart2
                        v-show="ageTrendAnalysisStatus"
                        :datalist='ageTrendAnalysisData'                     
                      />
                      <dv-loading v-if="!ageTrendAnalysisStatus"
                        >Loading...</dv-loading
                      >
                    </cusbox>
                  </div>
                </div>
                <div class="col">
                  <div class="ttt">
                    <cusbox txt="单价购买人数区间">
                      <lineChart
                        v-show="unitPricePurchaseRangeStatus"
                        lineColor="#F7517F"
                        type="unit_price_buyers"
                        ref="unit_price_buyers"
                      />
                      <dv-loading v-if="!unitPricePurchaseRangeStatus"
                        >Loading...</dv-loading
                      >
                    </cusbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="row" style="flex-direction: column">
            <div class="col m20">
              <div class="ttt">
                <cusbox txt="会员增长流失结构分析（活跃会员数TOP20门店）">
                  <scatter
                    v-show="increaseAndLossOfMembersStatus"
                    title="会员增长流失结构"
                    ref="scatter"
                  />
                  <dv-loading v-if="!increaseAndLossOfMembersStatus"
                    >Loading...</dv-loading
                  >
                </cusbox>
              </div>
            </div>
            <div class="col">
              <div class="ttt">
                <cusbox txt="会员结构分析">
                    <layout type="T_B">
                      <div flex=1></div>
                  <div style="display: flex;" flex=4>
                    <div style="flex: 1">
                      <pieChart2
                        v-show="analysisMembershipStructureStatus"
                        title="会员结构"
                        ref="membership_structure"
                        type="membership_structure"
                      />
                      <dv-loading v-if="!analysisMembershipStructureStatus"
                        >Loading...</dv-loading
                      >
                    </div>
                    <div style="flex: 1">
                      <pieChart2
                        v-show="activeMembershipStructureStatus"
                        title="活跃会员结构"
                        ref="active_members"
                        type="active_members"
                      />
                      <dv-loading v-if="!activeMembershipStructureStatus"
                        >Loading...</dv-loading
                      >
                    </div>
                  </div>
                    </layout>
                </cusbox>
              </div>
            </div>
          </div>
        </div>
      </div>

      <mobile class="device_phone ppd notransform" v-else>
        <div class="moblieline h150">
          <cusbox txt="会员指标">
            <div v-if="membershipIndicatorsStatus" class="vcontent">
              <div class="vrow1">
                <div class="row">
                  <div class="vitem">
                    <div class="vt1">会员总数</div>
                    <div class="vt2">
                      {{ data2[0].value / 10000
                      }}<font class="ten_thousand">万</font>
                      <div class="tip">
                        <span
                          class="animation"
                          style="position: absolute"
                          v-if="data2[0].state == 'up'"
                          >+{{ data2[0].changValue }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="vitem">
                    <div class="vt1">新增</div>
                    <div class="vt2">
                      {{ data2[1].value / 10000
                      }}<font class="ten_thousand">万</font>
                      <div class="tip">
                        <span
                          class="animation"
                          style="position: absolute"
                          v-if="data2[1].state == 'up'"
                          >+{{ data2[1].changValue }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="vitem">
                    <div class="vt1">去年同期新增</div>
                    <div class="vt2">
                      {{ data2[2].value / 10000
                      }}<font class="ten_thousand">万</font>
                    </div>
                  </div>
                </div>
                <div class="row" >
                  <div class="vitem">
                    <div class="vt1">有效会员</div>
                    <div class="vt2">
                      {{ data2[3].value / 10000
                      }}<font class="ten_thousand">万</font>
                      <div class="tip">
                        <span
                          class="animation"
                          style="position: absolute"
                          v-if="data2[3].state == 'up'"
                          >+{{ data2[3].changValue }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="vitem">
                    <div class="vt1">平均件单价</div>
                    <div class="vt2">
                      {{ data2[4].value }}<font class="ten_thousand">元</font>
                    </div>
                  </div>
                  <div class="vitem">
                    <div class="vt1">平均客单价</div>
                    <div class="vt2">
                      {{ data2[5].value }}<font class="ten_thousand">元</font>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <dv-loading v-if="!membershipIndicatorsStatus"
              >Loading...</dv-loading
            >
          </cusbox>
        </div>

        <div class="moblieline">
          <cusbox txt="会员消费排行 TOP50">
            <dv-loading v-if="!memberConsumptionRankStatus"
              >Loading...</dv-loading>
            <barChartX2
              v-show="memberConsumptionRankStatus"
              :radius="radius"
              ref="member_consumption"
              type="member_consumption"
              :data="x2data"
            />
          </cusbox>
        </div>
        <div class="moblieline h400">
          <cusbox txt="会员等级及活跃度">
            <barChartY2 :bw='5' v-show="membershipLevelAndActivityStatus" ref="aaa" />
            <dv-loading v-if="!membershipLevelAndActivityStatus"
              >Loading...</dv-loading
            >
          </cusbox>
        </div>
        <div class="moblieline h300">
          <cusbox txt="渠道会员占比">
            <barChart
              v-show="proportionChannelMembersStatus"
              :data="obj"
              rotate="40"
              ref="channel_member"
            />
            <dv-loading v-if="!proportionChannelMembersStatus"
              >Loading...</dv-loading
            >
          </cusbox>
        </div>
        <div class="moblieline">
          <cusbox txt="活跃会员数门店排行 TOP20">
            <barChartX2
              v-show="activeMemberStoreRankingStatus"
              ref="shopactive_members"
              type="shopactive_members"
              :radius="radius"
              :data="x2data"
            />
            <dv-loading v-if="!activeMemberStoreRankingStatus"
              >Loading...</dv-loading
            >
          </cusbox>
        </div>
        <div class="moblieline">
          <cusbox txt="消费年龄趋势分析">
            <lineChart2
              v-show="ageTrendAnalysisStatus"
              :datalist='ageTrendAnalysisData'
            />
            <dv-loading v-if="!ageTrendAnalysisStatus">Loading...</dv-loading>
          </cusbox>
        </div>
        <div class="moblieline">
          <cusbox txt="单价购买人数区间">
            <lineChart
              v-show="unitPricePurchaseRangeStatus"
              lineColor="#F7517F"
              type="unit_price_buyers"
              ref="unit_price_buyers"
            />
            <dv-loading v-if="!unitPricePurchaseRangeStatus"
              >Loading...</dv-loading
            >
          </cusbox>
        </div>
        <div class="moblieline h400">
          <cusbox txt="会员增长流失结构分析">
            <scatter
              v-show="increaseAndLossOfMembersStatus"
              title="会员增长流失结构"
              ref="scatter"
            />
            <dv-loading v-if="!increaseAndLossOfMembersStatus"
              >Loading...</dv-loading
            >
          </cusbox>
        </div>
        <div class="moblieline h550">
          <cusbox txt="会员结构分析">
             <layout type="T_B">
  <div style="flex: 1">
                <pieChart2
                  v-show="analysisMembershipStructureStatus"
                  title="会员结构"
                  ref="membership_structure"
                  type="membership_structure"
                />
                <dv-loading v-if="!analysisMembershipStructureStatus"
                  >Loading...</dv-loading
                >
              </div>
              <div style="flex: 1">
                <pieChart2
                  v-show="activeMembershipStructureStatus"
                  title="活跃会员结构"
                  ref="active_members"
                  type="active_members"
                />
                <dv-loading v-if="!activeMembershipStructureStatus"
                  >Loading...</dv-loading
                >
              </div>
             </layout>
            
            
           
          </cusbox>
        </div>
      </mobile>
    </div>
  </div>
</template>
<style lang="scss" scope>
* {
  box-sizing: border-box;
}
body,
html {
  height: 100%;
}
.screen {
  background-size: 100% 100%;
  background-image: url(../../assets/bg.png);
  display: flex;
  flex-direction: column;
  height: 100%;
  .m20 {
    margin-top: -20px;
  }
  .hyzb {
    margin-top: -20px;
    flex: none !important;
  }
  .vcontent {
    color: #fff;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    height: 100%;

    .vrow1 {
      flex: 1.5;
      display: flex;
      flex-direction: column;
      height: 100%;
    }
    .vitem {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: "#C0C8FF";
          justify-content: center;
      .vt1 {
        font-size: 14px;
        color: #c0c8ff;
      }
      .vt2 {
        font-size: 30px !important;
        position: relative;
        color: "#FFFFFF";
        .tip {
          position: absolute;
          right: 0px;
          top: -6px;
          font-size: 18px;
          color: #4faeff;
          transform: translateX(100%) translateX(15px);
        }
      }
    }
    .vitem2 {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }
  .mytt {
    position: absolute;
    right: -2px;
    left: 30px;
    top: -15px;
    height: 36px;
  }
  .mtt {
    height: 100%;
    padding-bottom: 20px;
    margin-top: -30px;
  }

  .rv {
    flex-direction: column;
  }
  .row.header {
    height: 80px;
    flex: none;
  }
  .row.content {
    flex-direction: column;
    padding: 8px 10px;
    .ttt {
      padding: 8px;
      width: 100%;
    }
  }
  .row {
    display: flex;
    flex: 1;
    .col {
      flex: 1;

      display: flex;
    }
    .col.col2 {
      flex: 2;
    }
  }
  .row.row1 {
    min-height: 164px;
    flex: 1;
  }
  .row.row2 {
    flex: 2;
    min-height: 164px;
  }

  .colgroup {
    display: flex;
    flex: 1;
    align-items: center;
    .group_item {
      flex: 1;
    }
  }
  .ten_thousand {
    font-size: 24px;
    color: "#000000";
  }

  .animation {
    -webkit-animation: fadeOutUp 1s 2s ease both;
    -moz-animation: fadeOutUp 1s 2s ease both;
  }
  @keyframes fadeOutUp {
    0% {
      opacity: 1;
      -webkit-transform: translateY(0);
    }
    100% {
      opacity: 0;
      -webkit-transform: translateY(-20px);
    }
  }

  //             .animation{
  // -webkit-animation:fadeInUp 1s .2s ease both;
  // -moz-animation:fadeInUp 1s .2s ease both;}
  // @-webkit-keyframes fadeInUp{
  // 0%{opacity:0;
  // -webkit-transform:translateY(20px)}
  // 100%{opacity:1;
  // -webkit-transform:translateY(0)}
  // }
  // @-moz-keyframes fadeInUp{
  // 0%{opacity:0;
  // -moz-transform:translateY(20px)}
  // 100%{opacity:1;
  // -moz-transform:translateY(0)}
  // }
}
</style>
<script>
import mhead from "@/components/cuscom/mhead"
import layout from "@/components/cuscom/layout.vue";
import cusbox from "@/components/vip/cusbox";
import indicator from "@/components/vip/indicator";
import cusspecialbox from "@/components/vip/cusspecialbox";
import cusmenu from "@/components/vip/cusmenu";
import {
  barChart,
  barChartX,
  barChartX2,
  pieChart,
  lineChart,
   lineChart2,
  pieChartM,
  scaChart,
  barChartY,
  pieChartD,
  barChartY2,
  pieChart2,
  scatter,
} from "@/components/vip/charts";
import {
  membershipIndicators,
  proportionChannelMembers,
  memberConsumptionRank,
  activeMemberStoreRanking,
  analysisMembershipStructure,
  activeMembershipStructure,
  ageTrendAnalysis,
  unitPricePurchaseRange,
  membershipLevelAndActivity,
  increaseAndLossOfMembers,
} from "@/api/member.js";
import { cols_1, cols_2 } from "./device/phone_column.js";
export default {
  inject: ["root"],
  data() {
    return {
      radius: [0, 0, 0, 0],
      currentChange: 1,
      currentDate: 1,
      data2: [
        { state: "", changValue: 0, value: 0 },
        { state: "", changValue: 0, value: 0 },
        { state: "", changValue: 0, value: 0 },
        { state: "", changValue: 0, value: 0 },
        { state: "", changValue: 0, value: 0 },
        { state: "", changValue: 0, value: 0 },
      ],
      obj: {
        y: [],
        value: [{ data: [] }, { data: [] }],
      },
      //['深圳光明大仟里','广州K11店', '广州北京路225店', '重庆西城天街', '西安熙地港','西安熙地港2'],
      //[900,970, 1080, 1140, 1200, 900],
      //[1,2,3,4,5,6]
      x2data: {},
      consumption_top50: [], //消费排行50条所有数据
      shopactive_top20: [], //活跃会员数门店排行top20
      shopactive_display_number: 7, ////活跃会员数门店排行top20显示个数
      consumption_display_number: 5, //消费排行top50显示个数
      that_data_channel: {},
      data_channel_display_number: 6, //渠道会员占比显示个数
       ageTrendAnalysisData:[],
      membershipIndicatorsStatus: false,
      memberConsumptionRankStatus: false,
      membershipLevelAndActivityStatus: false,
      activeMemberStoreRankingStatus: false,
      ageTrendAnalysisStatus: false,
      unitPricePurchaseRangeStatus: false,
      increaseAndLossOfMembersStatus: false,
      analysisMembershipStructureStatus: false,
      proportionChannelMembersStatus: false,
      activeMembershipStructureStatus: false,

      compaerdata: {},
    };
  },
  watch: {
    memberConsumptionRankStatus() {
      var that = this;
        if(this.timer1){
         clearInterval(this.timer1)
        }
      this.timer1=setInterval(function () {
        that.member_consumption();
      }, 2000);
    },
    activeMemberStoreRankingStatus() {
      var that = this;
      if(this.timer2){
       clearInterval(this.timer2)
      }
      this.timer2=setInterval(function () {
        that.shopactive_members();
      }, 2000);
    },
    proportionChannelMembersStatus() {
      var that = this;
      if(this.timer3){
        clearInterval(this.timer3)
      }
      this.timer3=setInterval(function () {
        that.channel_member();
      }, 2000);
    },
  },
  methods: {
    echange(data) {
      var that = this;
      this.currentChange = data.currentChange;
      this.currentDate = data.currentDate;
    },
    ////会员等级及活跃度
    doan(cindex) {
      this.$refs.aaa.ff.dispatchAction({
        type: "showTip",
        seriesIndex: 0,
        dataIndex: cindex,
      });
    },

    //单价购买人数区间
    unit_price_buyers(cindex) {
      this.$refs.unit_price_buyers.ff.dispatchAction({
        type: "showTip",
        seriesIndex: 0,
        dataIndex: cindex,
        axisIndex: 1,
      });
    },
    //会员结构
    membership_structure(cindex) {
      //高亮图形
      this.$refs.membership_structure.ff.dispatchAction({
        type: "highlight",
        seriesIndex: 0,
        dataIndex: cindex,
      });

      // 取消之前高亮的图形
      this.$refs.membership_structure.ff.dispatchAction({
        type: "downplay",
        seriesIndex: 0,
        dataIndex: cindex == 0 ? 3 : cindex - 1,
      });
    },

    //活跃会员结构
    active_members(cindex) {
      //高亮图形
      this.$refs.active_members.ff.dispatchAction({
        type: "highlight",
        seriesIndex: 0,
        dataIndex: cindex,
      });

      // 取消之前高亮的图形
      this.$refs.active_members.ff.dispatchAction({
        type: "downplay",
        seriesIndex: 0,
        dataIndex: cindex == 0 ? 3 : cindex - 1,
      });
    },
    //会员消费排行榜TOP50（滚动）
    member_consumption() {
      var that = this;
      var ydata = this.$refs.member_consumption.option.yAxis.data;
      var y = ydata.pop();
      //ydata.unshift(y);
      var data0 = this.$refs.member_consumption.option.series[0].data;
      var data = data0.pop();
      //data0.unshift(data);
      ydata.unshift(
        that.consumption_top50[that.consumption_display_number].ydata
      );
      data0.unshift(
        that.consumption_top50[that.consumption_display_number].value
      );
      var f = that.consumption_top50.shift();
      that.consumption_top50.push(f);
      if(this.timer5){
       clearInterval(this.timer5)
      }
      this.timer5=setInterval(function () {
        that.$refs.member_consumption.ff.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: 2,
        });
      }, 10);
    },
    //活跃会员数(滚动)
    shopactive_members() {
      var that = this;
      var data0 = this.$refs.shopactive_members.option.series[0].data;
      var data = data0.pop();
      //data0.unshift(data);
      var ydata = this.$refs.shopactive_members.option.yAxis.data;
      var y = ydata.pop();
      // ydata.unshift(y);

      var f = that.shopactive_top20.shift();
      that.shopactive_top20.push(f);
      ydata.unshift(
        that.shopactive_top20[that.shopactive_display_number - 1].ydata
      );
      data0.unshift(
        that.shopactive_top20[that.shopactive_display_number - 1].value
      );
       if(this.timer6){
        clearInterval(this.timer6)
       }
      this.timer6=setInterval(function () {
        that.$refs.shopactive_members.ff.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: 3,
        });
      }, 10);
    },
    //会员增长流失结构分析
    scatter(cindex) {
      this.$refs.scatter.ff.dispatchAction({
        type: "showTip",
        seriesIndex: 0,
        dataIndex: cindex,
      });
    },
    //渠道会员占比(滚动)
    channel_member() {    
      var data0 = this.$refs.channel_member.option.series[0].data;
      var data = data0.shift();
    
      var data1 = this.$refs.channel_member.option.series[1].data;
      var dat1 = data1.shift();    

      var xdata = this.$refs.channel_member.option.xAxis.data;
      var x = xdata.shift();    
      var that = this;
      data0.push(
        that.that_data_channel.value[0].data[this.data_channel_display_number]
      );
      data1.push(
        that.that_data_channel.value[1].data[this.data_channel_display_number]
      );
      xdata.push(that.that_data_channel.y[this.data_channel_display_number]);

      var data1 = that.that_data_channel.value[0].data.shift();
      var data2 = that.that_data_channel.value[1].data.shift();
      var ydata = that.that_data_channel.y.shift();

      that.that_data_channel.value[0].data.push(data1);
      that.that_data_channel.value[1].data.push(data2);
      that.that_data_channel.y.push(ydata);
    },
    //排序 从大到小
    compare(prop) {
      return function (a, b) {
        let v1 = a[prop];
        let v2 = b[prop];
        // return v1 - v2; //从小到大
        return v2 - v1; //从大到小
      };
    },
    asc(prop) {
      return function (a, b) {
        let v1 = a[prop];
        let v2 = b[prop];
        return v1 - v2; //从小到大
        // return v2 - v1; //从大到小
      };
    },
    //消费排行top50数据处理
    data_processing() {
      var that = this;
      var chartx2_ydata = [];
      var chartx2_data = [];
      var ranking_data = [];
      var x2data2 = [];
      memberConsumptionRank().then(function (result) {
        if (result) {
          var cuslist = result.data.list;
          cuslist.forEach((item) => {
            var o = {};
            o.ranking = item.rank;
            o.value = item.money;
            o.ydata = item.name ? item.name : "会员" + item.rank;
            x2data2.push(o);
          });
          that.memberConsumptionRankStatus = true;
          that.consumption_top50 = x2data2;
          x2data2.sort(that.compare("ranking"));
          that.consumption_top50.sort(that.asc("ranking"));

          var index = that.consumption_display_number;
          for (var i = 0; i < that.consumption_display_number; i++) {
            index--;
            chartx2_ydata.push(that.consumption_top50[index].ydata);
            chartx2_data.push(that.consumption_top50[index].value);
          }

          that.x2data = { value: chartx2_data, ydata: chartx2_ydata };
          setTimeout(function () {
            that.$refs.member_consumption.option.series[0].data = chartx2_data;
            that.$refs.member_consumption.option.yAxis.data = chartx2_ydata;
            that.$refs.member_consumption.option.yAxis.offset = 90;

            that.$refs.member_consumption.option.yAxis.axisLabel = {
              color: function (value, index) {
                if (index == 2) {
                  return "#EACD2C";
                } else {
                  return "#fff";
                }
              },
              formatter: function (value, index) {
                let str =
                  value.length > 3 ? value.substring(0, 3) + "..." : value;
                var ind = 3;
                x2data2.forEach((item) => {
                  if (item.ydata == value) {
                    if (item.ranking == 1) {
                      ind = 0;
                      return;
                    }
                    if (item.ranking == 2) {
                      ind = 1;
                      return;
                    }
                    if (item.ranking == 3) {
                      ind = 2;
                      return;
                    } else {
                      ind = item.ranking;
                    }
                  }
                });
                if (ind >= 3) {
                  return `{img3|${ind}}  {value|${str}}`;
                }
                return `{img${ind}|}  {value|${str}}`;
              },
            };
          }, 1000);
        }
      });
    },
    //活跃会员数门店排行top20 数据处理
    data_shopactive_members() {
      var that = this;
      var chartx2_ydata = [];
      var chartx2_data = [];
      var ranking_data = [];
      var x2data2 = [];
      activeMemberStoreRanking().then(function (result) {
        if (result) {
          var cuslist = result.data.list;
          cuslist.forEach((item) => {
            var o = {};
            o.ranking = item.ranking;
            o.value = item.member;
            o.ydata = item.name;
            x2data2.push(o);
          });
          that.activeMemberStoreRankingStatus = true;
          x2data2.sort(that.compare("ranking"));

          that.shopactive_top20 = x2data2;
          that.shopactive_top20.sort(that.asc("ranking"));

          //以下循环获取前7个进行显示
          var index = that.shopactive_display_number;
          for (var i = 0; i < that.shopactive_display_number; i++) {
            index--;
            chartx2_ydata.push(that.shopactive_top20[index].ydata);
            chartx2_data.push(that.shopactive_top20[index].value);
          }

          that.x2data = { value: chartx2_data, ydata: chartx2_ydata };

          setTimeout(function () {
            that.$refs.shopactive_members.option.series[0].data = chartx2_data;
            that.$refs.shopactive_members.option.yAxis.data = chartx2_ydata;
            that.$refs.shopactive_members.option.yAxis.offset = 130;
            that.$refs.shopactive_members.option.series[0].itemStyle = {
              normal: {
                borderType: "solid",
                color: function (params) {
                  var c = "";
                  if (params.dataIndex == 3) {
                    c = "#EACD2C";
                  } else {
                    c = "#377DFF";
                  }
                  return c;
                },
              },
            };
            that.$refs.shopactive_members.option.yAxis.axisLabel = {
              color: function (value, index) {
                if (index == 3) {
                  return "#EACD2C";
                } else {
                  return "#fff";
                }
              },
              formatter: function (value, index) {
                let str =
                  value.length > 6 ? value.substring(0, 6) + "..." : value;
                var ind = 3;

                x2data2.forEach((item) => {
                  if (item.ydata == value) {
                    if (item.ranking == 1) {
                      ind = 0;
                      return;
                    }
                    if (item.ranking == 2) {
                      ind = 1;
                      return;
                    }
                    if (item.ranking == 3) {
                      ind = 2;
                      return;
                    } else {
                      ind = item.ranking;
                    }
                  }
                });
                if (ind >= 3) {
                  return `{img3|${ind}}    {value|${str}}`;
                }
                return `{img${ind}|}    {value|${str}}`;
              },
            };
          }, 1000);
        }
      });
    },
    //渠道会员占比数据处理
    data_channel_member() {
      let that = this;
      proportionChannelMembers().then(function (result) {
        if (result) {
          var result_data = result.data.list;
          var y = [];
          var inActive = [];
          var active = [];
          result_data.forEach((item) => {
            if (item.name) {
              y.push(item.name);
              inActive.push(item.inActive);
              active.push(item.active);
            }
          });
          y.forEach((item) => {
            that.obj.y.push(item ? item : "");
          });
          inActive.forEach((item) => {
            that.obj.value[0].data.push(item);
          });
          active.forEach((item) => {
            that.obj.value[1].data.push(item);
          });
          that.proportionChannelMembersStatus = true;
          var channeldata = that.obj;

          that.that_data_channel = channeldata;

          var index = that.data_channel_display_number;

          var ydata2 = [];
          var value2 = [];
          var data3 = [];
          var data4 = [];
          for (var i = 0; i < that.data_channel_display_number; i++) {
            index--;
            ydata2.push(channeldata.y[index]);
            data3.push(channeldata.value[0].data[index]);
            data4.push(channeldata.value[1].data[index]);
          }
          value2.push({ data: data3 });
          value2.push({ data: data4 });
          that.obj = {
            y: ydata2,
            value: value2,
          };
          that.$refs.channel_member.option.series[0].data =
            that.obj.value[0].data;
          that.$refs.channel_member.option.series[1].data =
            that.obj.value[1].data;
          that.$refs.channel_member.option.xAxis.data = that.obj.y;
        }
      });
    },
    getData() {
      var that = this;
      return new Promise(function (r, l) {
        membershipIndicators().then(function (result) {
          if (result) {
            var olddata = that.data2;           
            var current = [];

            if (that.membershipIndicatorsStatus) {
              current[0] = result.data.totalMembership - olddata[0].value;
              current[1] = result.data.newMembership - olddata[1].value;
              current[2] = result.data.lastYearNewMembership - olddata[2].value;
              current[3] = result.data.effectiveMembership - olddata[3].value;
              current[4] = result.data.averageCustomerPrice - olddata[4].value;
              current[5] = result.data.averageUnitPrice - olddata[5].value;
            } else {
              current[0] = 0;
              current[1] = 0;
              current[2] = 0;
              current[3] = 0;
              current[4] = 0;
              current[5] = 0;
            }         
            that.data2 = [
              {
                state: current[0] > 0 ? "up" : "",
                changValue: current[0],
                value: result.data.totalMembership,
              },
              {
                state: current[1] > 0 ? "up" : "",
                changValue: current[1],
                value: result.data.newMembership,
              },
              {
                state: current[2] > 0 ? "up" : "",
                changValue: current[2],
                value: result.data.lastYearNewMembership,
              },
              {
                state: current[3] > 0 ? "up" : "",
                changValue: current[3],
                value: result.data.effectiveMembership,
              },
              {
                state: current[4] > 0 ? "up" : "",
                changValue: current[4],
                value: result.data.averageCustomerPrice,
              },
              {
                state: current[5] > 0 ? "up" : "",
                changValue: current[5],
                value: result.data.averageUnitPrice,
              },
            ];          
            that.membershipIndicatorsStatus = true;
            r("success");
          }
        });

        // setTimeout(function(){
        //                var olddata=that.data2;
        //                  var current=[]

        //                   if(that.membershipIndicatorsStatus){
        //                         current[0]=olddata[0].changValue+10;
        //                         current[1]=olddata[1].changValue+10;
        //                         current[2]=olddata[2].changValue+10;
        //                         current[3]=olddata[3].changValue+10;
        //                         current[4]=olddata[4].changValue+10;
        //                         current[5]=olddata[5].changValue+10;
        //                   }else{
        //                         current[0]=0;
        //                         current[1]=0;
        //                         current[2]=0;
        //                         current[3]=0;
        //                         current[4]=0;
        //                         current[5]=0;
        //                   }

        //                 that.data2=[
        //                         {state:current[0]>0?"up":"",changValue:current[0],value:100},
        //                         {state:current[1]>0?"up":"",changValue:current[1],value:100},
        //                         {state:current[2]>0?"up":"",changValue:current[2],value:100},
        //                         {state:current[3]>0?"up":"",changValue:current[3],value:100},
        //                         {state:current[4]>0?"up":"",changValue:current[4],value:100},
        //                         {state:current[5]>0?"up":"",changValue:current[5],value:100}
        //                 ]
        //                 that.membershipIndicatorsStatus=true;
        //                 r("success")

        // },2000)
      });
    },
    reset() {
      this.data2.forEach((res) => {
        res.state = "";
      });
    },
    test() {
      var that = this;

      if (!that.isLoad) {
        setTimeout(function () {
          that.reset();
          that.getData().then((res) => {
            that.isLoad = false;

            that.test();
          });
        }, 3000);
      }
    },
  },
  mounted() {
    this.test();

    var that = this;
    //会员等级及活跃度
    this.$nextTick((res) => {
      let cindex = 0;
      membershipLevelAndActivity().then(function (result) {
        if (result) {
          var a = {};
          a = result.data;

          that.$refs.aaa.option.series[0].data = [
            a.v1_allMember,
            a.v2_allMember,
            a.v3_allMember,
            a.v4_allMember,
            a.v5_allMember,
          ];
          that.$refs.aaa.option.series[1].data = [
            a.v1_active,
            a.v2_active,
            a.v3_active,
            a.v4_active,
            a.v5_active,
          ];
          that.$refs.aaa.option.series[2].data = [
            a.v1_MONEY,
            a.v2_MONEY,
            a.v3_MONEY,
            a.v4_MONEY,
            a.v5_MONEY,
          ];
          that.$refs.aaa.option.series[3].data = [
            a.v1_ORDERNUM,
            a.v2_ORDERNUM,
            a.v3_ORDERNUM,
            a.v4_ORDERNUM,
            a.v5_ORDERNUM,
          ];
          that.membershipLevelAndActivityStatus = true;
          that.doan(cindex);
          cindex++;
          if(that.timer7){
            clearInterval(that.timer7)
          }
          that.timer7=setInterval(function () {
            if (cindex == 5) cindex = 0;
            that.doan(cindex);
            cindex++;
          }, 2000);
        }
      });
    });
    //消费年龄趋势分析
    this.$nextTick((res) => {
    var that=this;
      ageTrendAnalysis().then(function (result) {
        if (result) {
          var x2data2 = []; 
          let ms=[];
          for (let index = 1; index <= 12; index++) {
            const element = index;
            ms.push(element)
            
          }          
          x2data2= ms.map((item,index) => {   
             return  result.data.list[index]?result.data.list[index].avgAge:0.1;
          });
          
          that.ageTrendAnalysisData=x2data2;
          that.ageTrendAnalysisStatus = true;
        }
      });
    });
    //单价购买人数区间
    this.$nextTick((res) => {
      let cindex = 0;

      unitPricePurchaseRange().then(function (result) {
        if (result) {
          var x2data2 = {};
          x2data2 = result.data;
          that.$refs.unit_price_buyers.option.series[0].data.push(
            x2data2.price300
          );
          that.$refs.unit_price_buyers.option.series[0].data.push(
            x2data2.price500
          );
          that.$refs.unit_price_buyers.option.series[0].data.push(
            x2data2.price700
          );
          that.$refs.unit_price_buyers.option.series[0].data.push(
            x2data2.price900
          );
          that.$refs.unit_price_buyers.option.series[0].data.push(
            x2data2.price1100
          );
          that.$refs.unit_price_buyers.option.series[0].data.push(
            x2data2.price1100plus
          );
          that.unitPricePurchaseRangeStatus = true;
          that.unit_price_buyers(cindex);
          cindex++;
          if(that.timer9){
            clearInterval(that.timer9)
          }
         that.timer9= setInterval(function () {
            if (cindex == 6) cindex = 0;
            that.unit_price_buyers(cindex);
            cindex++;
          }, 2000);
        }
      });
    });
    //会员结构
    this.$nextTick((res) => {
      let cindex = 0;
      analysisMembershipStructure().then(function (result) {
        if (result) {
          var x2data2 = {};
          x2data2 = result.data;

          that.$refs.membership_structure.option.series[0].avoidLabelOverlap = true;
          that.$refs.membership_structure.option.series[0].data = [
            {
              value: x2data2.active.toFixed(2),
              name: "活跃会员",
              itemStyle: { color: "#4346D3" },
            },
            {
              value: x2data2.sleep.toFixed(2),
              name: "沉睡会员",
              itemStyle: { color: "#2D99FF" },
            },
            {
              value: x2data2.silence.toFixed(2),
              name: "沉默会员",
              itemStyle: { color: "#6648FF" },
            },
            {
              value: x2data2.lost.toFixed(2),
              name: "流失会员",
              itemStyle: { color: "#43D3C9" },
            },
          ];

          that.analysisMembershipStructureStatus = true;
          that.membership_structure(cindex);
          cindex++;
          if(that.timer10){
             clearInterval(that.timer10)
          }
          that.timer10=setInterval(function () {
            if (cindex == 4) cindex = 0;
            that.membership_structure(cindex);
            cindex++;
          }, 2000);
        }
      });
    });
    //  活跃会员结构
    this.$nextTick((res) => {
      let cindex = 0;

      activeMembershipStructure().then(function (result) {
        if (result) {
          var x2data2 = {};
          x2data2 = result.data;

          that.$refs.active_members.option.series[0].data = [
            {
              value: x2data2.once,
              name: "重复两次购买",
              itemStyle: { color: "#4346D3" },
            },
            {
              value: x2data2.twice,
              name: "重复3次购买",
              itemStyle: { color: "#2D99FF" },
            },
            {
              value: x2data2.third,
              name: "重复3+次购买",
              itemStyle: { color: "#6648FF" },
            },
            {
              value: x2data2.more,
              name: "单次购买",
              itemStyle: { color: "#43D3C9" },
            },
          ];
          that.activeMembershipStructureStatus = true;
          that.active_members(cindex);
          cindex++;
          if(that.timer11){
               clearInterval(that.timer11)
          }
         that.timer11= setInterval(function () {
            if (cindex == 4) cindex = 0;
            that.active_members(cindex);
            cindex++;
          }, 2000);
        }
      });
    });
    //会员消费排行榜TOP50
    this.$nextTick((res) => {
      that.data_processing();
    });
    //TOP20
    this.$nextTick((res) => {
      that.data_shopactive_members();
    });
    //会员增长流失结构分析
    this.$nextTick((res) => {
      let cindex = 0;

      increaseAndLossOfMembers().then(function (result) {
        if (result) {
          var x2data2 = [];
          x2data2 = result.data.list;
          x2data2.forEach((item) => {
            var a = [];
            a.push(item.increase);
            a.push(item.lost);
            a.push(item.name);
            that.$refs.scatter.option.series[0].data.push(a);
          });
          that.increaseAndLossOfMembersStatus = true;
          that.scatter(cindex);
          cindex++;
          if(that.timer12){
              clearInterval(that.timer12)
          }
          that.timer12=setInterval(function () {      
            if (cindex == 20) cindex = 0;
            that.scatter(cindex);
            cindex++;
          }, 2000);
        }
      });
    });
    // 渠道会员占比
    this.$nextTick((res) => {
      this.$nextTick((res) => {
        that.data_channel_member();
      });
    });
  },
      beforeDestroy: function() {

            for (let index = 1; index <= 12; index++) {              
              if (this["timer"+index]) {
                  clearInterval(this["timer"+index]);
              }
              
            }
            
        },
  components: {
     mhead,
    cusbox,
    indicator,
    cusspecialbox,
    cusmenu,
    barChart,
    barChartX,
    barChartX2,
    pieChart,
    lineChart,
    pieChartM,
    scaChart,
    barChartY,
    pieChartD,
    barChartY2,
    pieChart2,
    scatter,
    layout,
     lineChart2,
  },
};
</script>